import React from "react";
import IframeResizer from '@iframe-resizer/react';
import * as styles from './index.module.scss';

const IframeBlock = ({ iframe }) => {
    const htmlString = JSON.parse(iframe.iframe.raw).content[0].content[0].value;

    if (iframe.title.toLowerCase() === "bim iframe") {
        return (
            <div className={`${styles.iframeWrapper} ${styles.bimIframe}`}>
                <IframeResizer
                    license={"GPLv3"}
                    title={iframe.title}
                    src={htmlString.match(/src="([^"]*)"/)[1]}
                    checkOrigin={false}
                    style={{ width: '100%', minHeight: '500px' }}
                />
            </div>
        );
    } else {
        return (
            <div
                className={`${styles.iframeWrapper} ${iframe.title.toLowerCase() === "parts arena iframe" ? styles.partsArenaIframe : ""}`}
                dangerouslySetInnerHTML={{
                    __html: htmlString,
                }}
            ></div>
        );
    }
};

export default IframeBlock;